
module.exports = class TitleLinkSmall extends React.Component
  displayName: 'TitleLinkSmall'

  constructor: (props) ->
      super(props)
      @state = { title: @props.title }

  componentDidMount: () =>
      if @props.editor is 'MathJax'
          window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub, @domElement])
      if (@props) and (@props.title.length < 1)
          title = "Untitled"
          @setState({ title: title })


  setDOMRef: (domElement) =>
    @domElement = domElement

  render: =>

    if @props.editor is 'MathJax'
      <button className="mathjax btn btn-link"
              ref={@setDOMRef}
              onClick={@props.onClick}
              dangerouslySetInnerHTML={{__html: @state.title }}>
      </button>
    else
      <button className="btn btn-link"
              onClick={@props.onClick}
              dangerouslySetInnerHTML={{__html: @state.title }}>
      </button>
